<template lang="html">
  <div>
    <v-dialog
      v-model="CreatedAlbumsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
       <!-- modal image -->
        <div id="myModalImage" class="modalc">
            <div id="headcaption">
                <v-container>
                    <v-layout row wrap justify-center align-center>
                      <v-flex xs2 md2 sm2 style="text-align: center; padding: 10px 10px 10px 10px;">
                        <v-icon class="fz-20 color-white" @click="downloadFile(detail_modal.path, detail_modal.name)">fa-solid fa-download</v-icon>
                      </v-flex>
                        <v-flex xs8 md8 sm8 style="text-align: center; padding: 10px 10px 10px 20px;">
                            <p class="mb-0 text-overflow-modal">{{detail_modal.name}}</p>
                            <p class="mb-0">{{date(detail_modal.timestamp)}} | {{time(detail_modal.timestamp)}}</p>
                        </v-flex>
                        <v-flex xs2 md2 sm2 style="text-align: right; padding: 10px 10px 10px 20px;">
                            <span class="close" style="cursor: pointer;font-size: 30px;" @click="closemodal()">&times;</span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
            <img class="modal-contentc" id="img01">
        </div>

      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pl-2 pr-0 pt-0 pb-0 cursor"
          @click="close()"
        >
          <v-icon style="font-size: 30px !important;">mdi-close</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('Dialog.album.headerCreate')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pr-2 pl-0 pt-0 pb-0"
          >
          <b v-if="!statusAddImage" @click="createdAlbums()" :class="files.length === 0 ? 'text-btn-disable' : 'text-btn cursor'">{{$t('AnswerQuestion.keep')}}</b>
          <b v-if="statusAddImage" @click="createdAlbumsImage()" :class="image.length === 0 ? 'text-btn-disable' : 'text-btn cursor'">{{$t('AnswerQuestion.keep')}}</b>
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <!-- สร้างใหม่จากการเลือกรูปในห้องแชท -->
      <div v-if="statusAddImage" class="pt-3 pl-5 pr-5 pb-2 list-overflow">
        <v-col cols="12" align="start" class="pa-0">
          <v-textarea
            v-model="album_name"
            :placeholder="placeholderAlbum"
            no-resize
            outlined
            rows="3"
            row-height="25"
            counter="50"
            maxlength="50"
            clearable
          ></v-textarea>
        </v-col>

        <v-col cols="12" justify="end" align="center">
          <v-row justify-center align-center>
            <v-col
              class="d-flex child-flex pa-0"
              cols="4"
              v-for="(item, index) in image" :key="index"
            >
              <v-img
                :src="item.message"
                :lazy-src="item.message"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <v-row
                  class="fill-height ma-1"
                  align="start"
                  justify="end"
                >
                  <v-btn text icon color="white" small @click="deleteImageChat(item, index)">
                    <v-icon>fa-solid fa-xmark</v-icon>
                  </v-btn>
                </v-row>

                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-col>
      </div>
      <!-- สร้างใหม่จากการเลือกรูปใน devices -->
      <div v-else class="pt-3 pl-5 pr-5 pb-2 list-overflow">
        <v-col cols="12" align="start" class="pa-0">
          <v-textarea
            v-model="album_name"
            :placeholder="placeholderAlbum"
            no-resize
            outlined
            rows="3"
            row-height="25"
            counter="50"
            maxlength="50"
            clearable
          ></v-textarea>
        </v-col>
        <v-col cols="12" justify="end" align="start" class="pl-0">
          <b>{{$t('AnswerQuestion.selectPicture')}}</b>
        </v-col>
        <v-col cols="12" justify="end" align="center">
          <v-row justify-center align-center>
            <v-col class="d-flex child-flex pa-0" cols="4" align="center" justify="center" style="background-color: #e5e5e5; min-height: 116px;">
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
              <v-btn text icon color="grey" large @click="selectFile()">
                <v-icon class="fz-30">fa-solid fa-plus</v-icon>
              </v-btn>
              <input
                id="file-input-created"
                multiple
                type="file"
                style="display: none;"
                v-on:change="convertFile($event)"
                accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"
              ></input>
            </v-row>
            </v-col>
            <v-col
              class="d-flex child-flex pa-0"
              cols="4"
              v-for="(item, index) in files" :key="index"
            >
              <v-img
                :src="item.value"
                :lazy-src="item.value"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <v-row
                  class="fill-height ma-1"
                  align="start"
                  justify="end"
                >
                  <v-btn text icon color="white" small @click="deleteImage(index)">
                    <v-icon>fa-solid fa-xmark</v-icon>
                  </v-btn>
                </v-row>

                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-col>
      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <ListBottomMenu :ListBottomMenu="ListBottomMenu" :ListBottomItem="ListBottomItem" @emitListBottom="emitListBottom" @closeAlertDialog="closeAlertDialog"/>
  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import LinkPrevue from 'link-prevue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { vplayer, aplayer } from 'vue-hls-player'
import ListBottomMenu from '@/components/Alert/ListBottomMenu'

var _ = require('lodash')
export default {
  props: {
    CreatedAlbumsDialog: Boolean,
    AlbumsRoom: String,
    ListAlbumsDetail: Array,
    ListAlbumsImage: Array,
    tokenuser: String
  },
  data () {
    return {
      statusAddImage: false,
      placeholderAlbum: '',
      files: [],
      image: [],
      album_name: '',
      detail_modal: {},
      date_image: '',
      progress_btm: false,
      activeKey: '',
      activeTabName: '',
      // tokenuser: '',
      tokenroom: '',
      data_user: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      DetailAlbumsDialog: false,
      NoteDetail: {},
      EditAlbumsDialog: false,
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_image: [],
      list_file: [],
      list_link: [],
      status_edit: 'start',
      limit: 20,
      offset: 0,
      access_token: '',
      refresh_token: '',
      progress: false,
      nextgetMedia: true,
      thumbnail_video: '',
      muted_video: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        muted: false,
        fullscreen: true,
      },
      pageCount: 1,
      page: null,
      numPages: 1,
      urlpdf: '',
      filenamepdf: '',
      sources_video: [],
      list_albums: [],
      offset: 0,
      image_id: [],
      image_data: [],
      stylechat: {
        "--CreatedAlbumsChat-HeaderColor": "white",
        "--CreatedAlbumsChat-TabBackground": "white",
        "--CreatedAlbumsChat-Icon": "gray",
        "--CreatedAlbumsChat-HeaderPictureBorderRadius": "6px",
        "--CreatedAlbumsChat-IconActive": "#2662ae",
        "--CreatedAlbumsChat-Background": "white",
        "--CreatedAlbumsChat-FontSize": "18px",
        "--CreatedAlbumsChat-FontSize-Title": "24px",
        "--CreatedAlbumsChat-FontColor": "back",
        "--CreatedAlbumsChat-FontSize-Status": "16px",
        "--CreatedAlbumsChat-FontColor-Status": "grey",
        "--CreatedAlbumsChat-Background-Input": "#E2E1E3",
        "--CreatedAlbumsChat-Color-Button": "#EFF2FE",
        "--CreatedAlbumsChat-FontColor-Button": "#2662ae",
        "--CreatedAlbumsChat-FontColor-Block-Button": "#cb1002",
        "--CreatedAlbumsChat-FontColor-Dis-Button": "#e2e1e3",
        "--CreatedAlbumsChat-Btn-Confirm-Background": "#2662ae",
        "--CreatedAlbumsChat-Btn-Confirm-Color": "white",
        "--CreatedAlbumsChat-Btn-Confirm-FontSize": "18px",
        "--CreatedAlbumsChat-Btn-Cancel-Background": "white",
        "--CreatedAlbumsChat-Btn-Cancel-Color": "#2662ae",
        "--CreatedAlbumsChat-Btn-Cancel-FontSize": "18px",
        "--CreatedAlbumsChat-Btn-Leave-Background": "white",
        "--CreatedAlbumsChat-Btn-Leave-Color": "#ff5252",
        "--CreatedAlbumsChat-Btn-Leave-FontSize": "18px",
        "--CreatedAlbumsChat-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    ErrorAlert,
    Warning,
    LinkPrevue,
    vplayer,
    aplayer,
    VuePdfEmbed,
    ListBottomMenu,
  },
  watch: {
    CreatedAlbumsDialog () {
      if (this.CreatedAlbumsDialog) {
        this.tokenroom = this.AlbumsRoom
        this.access_token = this.$cookie.get('access_token')
        this.refresh_token = this.$cookie.get('refresh_token')
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        if (this.$cookie.get('language') === null || this.$cookie.get('language') === 'undefined') {
          yyyy = yyyy + 543
        } else {
          if (this.$cookie.get('language') == 'th') {
            yyyy = yyyy + 543
          } else {
            yyyy = yyyy - 543
          }
        }

        today = dd + '/' + mm + '/' + yyyy;
        this.placeholderAlbum = today
        if (this.ListAlbumsDetail !== undefined && this.ListAlbumsDetail !== 'undefined') {
          this.image = JSON.parse(localStorage.ListAlbumsDetail)
          // this.image_id = JSON.parse(localStorage.ListAlbumsDetail)
          // this.image_data = JSON.parse(localStorage.ListAlbumsImage)
          this.statusAddImage = true
        }
        // else {
        //   this.image = this.ListAlbumsImage
        //   this.statusAddImage = false
        // }
        // console.log(this.image)
      }
    },
    files () {
      if (this.files.length > 20) {
        this.ErrorDialogDetail = {
          title: '',
          text: this.$t('Alert.Fail.Album.maxFiles20')
        }
        this.ErrorDialog = true
        // _.pullAt(this.files, [20])
        var new_arr = this.files.slice(0, 20) // ตัดรูปที่เกินออก ให้เหลือไม่เกิน 20
        this.files = new_arr
      }
      // console.log(this.files)
    },
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile-private'))
    // this.data_user = user_profile
    // this.tokenuser = this.data_user.tokenuser
  },
  methods: {
    AddImageToAlbum (id) {
      var body = {
        albums_id: id,
        path_imgs: this.image[0].message,
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_EVENT + `/addimage_chatroom_to_albums`, body).then((response) => {
        if (response.data.status == 'success') {
          // console.log(response.data.data);
          this.progress = false
          this.image = []
          // ถ้าบันทึกข้อมูลเสร็จให้ลบข้อมูลท่ีเก็บไว้ออก
          // localStorage.removeItem('ListAlbumsDetail')
          // localStorage.removeItem('ListAlbumsImage')
          this.close()
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var data = {
            type: 'addImageById',
            key: ''
          }
          this.getNewAccess(this.access_token, this.refresh_token, data)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    createdAlbumsImage () {
      var name = ''
      if (this.album_name == '' || this.album_name == null) {
        name = this.placeholderAlbum
      } else {
        name = this.album_name
      }
      var body = new FormData()
      body.append('albums_name', name)
      body.append('tokenroom', this.tokenroom)
      body.append('tokenuser', this.tokenuser)
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_EVENT + `/create_album`, body).then((response) => {
        if (response.data.status == 'success') {
          // console.log(response.data.data);
          this.progress = false
          this.album_name = ''
          this.AddImageToAlbum(response.data.data.albums._id)
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var data = {
            type: 'createdAlbums',
            key: ''
          }
          this.getNewAccess(this.access_token, this.refresh_token, data)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    createdAlbums () {
      var name = ''
      if (this.album_name == '' || this.album_name == null) {
        name = this.placeholderAlbum
      } else {
        name = this.album_name
      }
      // console.log(this.files)
      var body = new FormData()
      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i].file
        body.append('file[]', file, file.name)
      }
      body.append('albums_name', name)
      body.append('tokenroom', this.tokenroom)
      body.append('tokenuser', this.tokenuser)
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_EVENT + `/create_album`, body).then((response) => {
        if (response.data.status == 'success') {
          // console.log(response.data.data);
          this.progress = false
          this.files = []
          this.album_name = ''
          this.close()
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var data = {
            type: 'createdAlbums',
            key: ''
          }
          this.getNewAccess(this.access_token, this.refresh_token, data)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    deleteImage (idx) {
      this.files.splice(idx, 1)
    },
    deleteImageChat (item, idx) {
      this.image.splice(idx, 1)
      var index = _.findIndex(this.image_id, function(o) { return o == item.message_id })
      if (index !== -1) {
        this.image_id.splice(index, 1)
      }
      // console.log(this.ListAlbumsDetail)
    },
    convertFile (data) {
      // console.log(data)
      var input = document.getElementById('file-input-created')
      var files = [...input.files]
      var fileInput = [...data.target.files]

      if (files && files[0]) {
        for (var i = 0; i < fileInput.length; i++) {
          this.files.push({
            name: fileInput[i].name,
            value: URL.createObjectURL(fileInput[i]),
            file: fileInput[i]
          })
        }
        // console.log(this.files)
      }
    },
    selectFile () {
      document.getElementById('file-input-created').click()
    },
    getAlbums () {
      if (this.offset == 0) {
        this.progress = true
      }
      this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/albums?room=${this.tokenroom}&limit=20&offset=${this.offset}`, {
        headers: { Authorization: `Bearer ${this.access_token}` }
      }).then((response) => {
        if (response.data.status == 200) {
          this.progress = false
          this.list_albums = response.data.data
          this.offset = this.offset + 1
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var data = {
            type: 'getAlbums',
            key: ''
          }
          this.getNewAccess(this.access_token, this.refresh_token, data)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    downloadFile(file, name) {
      // console.log(file)
      // console.log(name)
      this.axios.get(file, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
    handleDocumentRender() {
      // this.isLoading = false
      this.pageCount = this.$refs.myPdfComponent.pageCount
    },
    handlePasswordRequest(callback, retry) {
      callback(prompt(retry ?
        'Enter password again' :
        'This document is password protected. Please enter a password.'
      ))
    },
    openFilePDF (file) {
      // console.log(file)
      this.detail_modal = file
      this.urlpdf = file.path
      this.filenamepdf = file.name
      var modal = document.getElementById('myModalpdf')
      modal.style.display = 'block'
    },
    closemodal () {
      this.detail_modal = ''
      var modal = document.getElementById('myModalImage')
      modal.style.display = 'none'
      var modalpdf = document.getElementById('myModalpdf')
      modalpdf.style.display = 'none'

      this.thumbnail_video = ''
      this.muted_video = true
      // console.log(this.muted_video)
      this.videoOptions = {
        autoplay: false,
        controls: false,
        muted: true
      }
      // this.sources_video = []
      var modalvideo = document.getElementById('myModalVideo')
      modalvideo.style.display = 'none'
      // modalvideo.remove()
      // document.getElementById("my-element").remove()
      // console.log(this.videoOptions)
    },
    clicklink_website(url) {
      // this.checkBrowser(url, '')
      window.open(url, '_blank')
    },
    convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm', 'gsheet']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'fa-solid fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'fa-solid fa-file-video'
      } else if (audio.includes(extension)) {
        return 'fa-solid fa-file-audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    scrollFunction () {
      // var scroll = this.$el.querySelector('#myscrollNote')
      var scroll = document.getElementById("myscrollImage")
      // console.log(scroll.scrollTop)
      if (scroll !== null && scroll !== 'null') {
        if((scroll.scrollTop + scroll.clientHeight) >= (scroll.scrollHeight * 0.6)) {
          if (this.activeKey === '1') {
            // console.log('load image')
            this.getListImage()
          } else if (this.activeKey === '2') {
            // console.log('load file')
            this.getListFile()
          } else if (this.activeKey === '3') {
            // console.log('load link')
            this.getListLink()
          }
        } else {
          if (scroll.scrollTop === 0) {
            this.offset = 0
            this.nextgetMedia = true
          }
        }
      }
    },
    emitListBottom (value) {
      // console.log(value)
      this.ListBottomMenu = false
      if (value.item.actions === 'delete-album') {
        this.openDialog(value.item, value.item.index, 'delete-album')
      } else if (value.item.actions === 'edit-note') {
        this.NoteDetail = value.item.item
        this.EditAlbumsDialog = true
      }
    },
    emitComponents (value) {
      // console.log(value)
      if (value.name === 'create-note') {
        this.CreatedAlbumsDialog = false
        // this.getNote()
        this.list_image.unshift(value.item)
        this.list_image = _.unionBy(this.list_image, 'note_id')
        this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
      } else if (value.name === 'detail-note') {
        this.DetailAlbumsDialog = false
        // this.getNote()
      } else if (value.name === 'edit-note') {
        this.offset = 0
        this.list_image = []
        this.EditAlbumsDialog = false
        this.getNote()
      } else if (value.name === 'delete-album') {
        this.DetailAlbumsDialog = false
        var index = _.findIndex(this.list_albums, function(o) { return o.album_id === value.item.id })
        if (index !== -1) {
          this.list_albums.splice(index, 1)
        }
      }
    },
    openDialog (item, index, type) {
      // console.log(item)
      if (type === 'create') {
        this.CreatedAlbumsDialog = true
      } else if (type === 'edit') {
        this.ListBottomItem = [
          {
            text: this.$t('Dialog.album.btnAddImage'),
            icon: 'fa-solid fa-image',
            actions: 'add-image',
            id: item.album_id,
            index: index,
            item: item
          },
          {
            text: this.$t('Dialog.album.btnEdit'),
            icon: 'fa-solid fa-pen-to-square',
            actions: 'edit-album',
            id: item.album_id,
            index: index,
            item: item
          },
          {
            text: this.$t('Dialog.album.btnRemoveAlbum'),
            icon: 'fa-solid fa-trash-can',
            actions: 'delete-album',
            id: item.album_id,
            index: index
          }
        ]
        this.ListBottomMenu = true
      } else if (type === 'delete-album') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Album.deleteAlbum'),
          detail: item,
          index: index,
          type: 'delete-album'
        }
        this.WarningDialog = true
      } else if (type === 'edit-note') {
        this.NoteDetail = item
        this.EditAlbumsDialog = true
      } else if (type === 'detail-note') {
        // เอาไว้เช็คตอนกดปุ่มไอคอน list ว่าจะให้ปิดหน้ารายการโน้ตหรือให้แสดงอันใหม่ กรณีที่อยู่ในหน้าแชทหรือในหน้าโน้ต
        item.previous = 'list-note'
        this.NoteDetail = item
        this.DetailAlbumsDialog = true
      }
    },
    date (timestamp) {
      if (this.$cookie.get('language') === null || this.$cookie.get('language') === 'undefined') {
        return Momenttime.dayjsdatethai(timestamp)
      } else {
        if (this.$cookie.get('language') === 'th') {
          return Momenttime.dayjsdatethai(timestamp)
        } else {
          return Momenttime.dayjsdateen(timestamp)
        }
      }
    },
    time (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjstimethai(timestamp)
      } else {
        return Momenttime.dayjstimethai(timestamp)
      }
    },
    close () {
      this.files = []
      this.album_name = ''
      // console.log(this.ListAlbumsDetail)
      // console.log(this.ListAlbumsImage)
      this.$emit('closeComponents', {
        name: 'create-album',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'delete-album') {
        this.deleteAlbum(item.detail.id, item.index)
      }
    },
    closeComponents (data) {
      // console.log(data)
      if (data.name === 'create-note') {
        this.CreatedAlbumsDialog = data.value
      } else if (data.name === 'edit-note') {
        this.EditAlbumsDialog = data.value
      } else if (data.name === 'detail-note') {
        this.DetailAlbumsDialog = data.value
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    deleteAlbum (id, index) {
      this.progress = true
      // var body = { data: '' }
      this.axios.delete(process.env.VUE_APP_API_PRIVATE + `/v1/albums/${id}`, {
        headers: { Authorization: `Bearer ${this.access_token}` }
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 200) {
          this.progress = false
          this.list_albums.splice(index, 1)
          // console.log(this.list_image)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var item = {
            type: 'deleteAlbums',
            key: {
              album_id: id,
              album_index: index
            }
          }
          this.getNewAccess(this.access_token, this.refresh_token, item)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    getListImage () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/media?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_image.push.apply(this.list_image, response.data.data)
            this.list_image = _.unionBy(this.list_image, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_image)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListNote',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getListFile () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/files?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_file.push.apply(this.list_file, response.data.data)
            this.list_file = _.unionBy(this.list_file, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_file)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListFile',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getListLink () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/links?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_link.push.apply(this.list_link, response.data.data)
            this.list_link = _.unionBy(this.list_link, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_file)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListLink',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getNewAccess (oldaccess, oldrefresh, data) {
      var body = {
        access_token: oldaccess,
        refresh_token: oldrefresh
      }
      this.axios.post(process.env.VUE_APP_API_PRIVATE + `/v1/renew-access-token`, body, {
      }).then((response) => {
        if (response.data.status === 200) {
          // console.log(response.data.data)
          this.access_token = response.data.data.access_token
          this.refresh_token = response.data.data.refresh_token
          this.$cookie.set('access_token', response.data.data.access_token)
          this.$cookie.set('refresh_token', response.data.data.refresh_token)
          if (data.type === 'getAlbums') {
            this.getAlbums()
          } else if (data.type === 'deleteAlbum') {
            this.deleteAlbum(data.key.album_id, data.key.album_index)
          } else if (data.type === 'createdAlbums') {
            this.createdAlbums()
          }
        }
      }).catch(err => {
        // console.log(err)
        console.log(err.response.data)
      })
    },
  }
}
</script>

<style lang="css" scoped>
.cursor {
  cursor: pointer;
}
.text-btn {
  color: var(--CreatedAlbumsChat-FontColor-Button) !important
}
.text-btn-disable {
  color: var(--CreatedAlbumsChat-FontColor-Dis-Button) !important
}
.color-white {
    color: white !important;
}
.fz-20 {
  font-size: 20px !important;
}
>>>.player__controls--progress {
  flex: 1 !important;
  margin: 0 8px !important;
  z-index: 0 !important;
}
>>>.aplayer .player__controls--durration {
  color: rgb(0 0 0) !important;
}
>>>.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-family: Arial,Helvetica,sans-serif;
  word-break: initial;
  /* height: 100% !important; */
  width: 100% !important;
}
.modalc {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100vw;
    /* Full width */
    height: 100vh;
    /* Full height */
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
}

.modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    max-width: 95%;
    max-height: 80%;
}

#headcaption {
    margin: auto;
    display: block;
    text-align: left;
    color: #fff;
    padding-top: 1vh;
    padding-bottom: 1vh;
    background-color: var(--CreatedAlbumsChat-HeaderPictureBorderRadius) !important;
}
.height-80vh {
  height: 80vh;
  overflow: hidden;
}
.col-no-media {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: gray;
}
.text-overflow-link {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 60vw;
}
>>>.v-list-item .v-list-item__title {
  line-height: 2.0 !important;
}
.fz-19 {
  font-size: 19px;
}
.fw-600 {
  font-weight: 600;
}
.centerimg_website {
  justify-content: center;
  display: flex;
  margin-bottom: 10px;
}
.img_website {
  height: 50px;
  width: 50px;
  margin: auto;
  border-radius: 10px;
  object-fit: cover;
}
.layout-panels {
  height: calc(100vh - 140px) !important;
  /* height: 210px; */
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-panels::-webkit-scrollbar {
  width: 3px;
}

.layout-panels::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

>>>.ant-tabs-nav .ant-tabs-tab-active {
  color: var(--CreatedAlbumsChat-IconActive) !important;
  text-shadow: 0 0 0.25px currentColor !important;
}
>>>.ant-tabs-ink-bar {
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 0;
  box-sizing: border-box;
  height: 2px;
  background-color: var(--CreatedAlbumsChat-IconActive) !important;
  transform-origin: 0 0;
}
.font-list-title {
  font-weight: 600;
  color: var(--CreatedAlbumsChat-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.fz-50 {
  font-size: 50px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--CreatedAlbumsChat-FontSize-Title) !important;
  color: var(--CreatedAlbumsChat-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--CreatedAlbumsChat-FontSize-Title-Edit) !important;
  color: var(--CreatedAlbumsChat-FontColor) !important;
}
.tab-title {
  color: var(--CreatedAlbumsChat-FontColor) !important;
  font-size: var(--CreatedAlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--CreatedAlbumsChat-FontColor-Status) !important;
  font-size: var(--CreatedAlbumsChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 50vw;
}
.text-overflow-modal {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.checkbox-color {
  color: var(--CreatedAlbumsChat-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: scroll;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--CreatedAlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--CreatedAlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--CreatedAlbumsChat-Icon) !important;
}
.icon-color {
  color: var(--CreatedAlbumsChat-IconActive) !important;
}
.btn-confirm {
  background-color: var(--CreatedAlbumsChat-Btn-Confirm-Background) !important;
  color: var(--CreatedAlbumsChat-Btn-Confirm-Color) !important;
  font-size: var(--CreatedAlbumsChat-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--CreatedAlbumsChat-Btn-Cancel-Background) !important;
  color: var(--CreatedAlbumsChat-Btn-Cancel-Color) !important;
  font-size: var(--CreatedAlbumsChat-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--CreatedAlbumsChat-Btn-Leave-Background) !important;
  color: var(--CreatedAlbumsChat-Btn-Leave-Color) !important;
  font-size: var(--CreatedAlbumsChat-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--CreatedAlbumsChat-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--CreatedAlbumsChat-FontSize-Title) !important;
  color: var(--CreatedAlbumsChat-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--CreatedAlbumsChat-FontColor) !important;
  font-size: var(--CreatedAlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--CreatedAlbumsChat-FontColor-Status) !important;
  font-size: var(--CreatedAlbumsChat-FontSize-Status) !important;
}
/* .text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
} */
</style>
